import { DrawerModal } from '@fagmobler/ui';
import { MaterializedSeriePage } from '@fagmobler/sanity';
import { FagmoblerPortableText } from '@/components/portableText';

type AboutSeriesProps = {
  title: string;
  openedModal: string | null;
  closeModal: () => void;
  serieEnrichment: MaterializedSeriePage;
};

export const AboutSeriesModalKey = 'about_series';

export default function AboutSeries({
  title,
  openedModal,
  closeModal,
  serieEnrichment,
}: AboutSeriesProps) {
  return (
    <DrawerModal
      isOpen={openedModal === AboutSeriesModalKey}
      onClose={closeModal}
      title={title}
    >
      <div className="p-4 md:p-6 flex flex-col gap-4 items-start [&>*]:m-0">
        <FagmoblerPortableText
          value={serieEnrichment.body}
          baseClassName="body-sm font-normal text-neutral-70"
          forbidNegativeMargins
        />
      </div>
    </DrawerModal>
  );
}
